/**
 * Created by apokdev on 6/6/17.
 */
import React, {Component} from "react";
import {Link} from "react-router-dom";
import {hideHeader} from "../constants/functions";
import queryString from "query-string";

import Vacio from "./Vacio";
import Breadcrumb from "./Breadcrumbs";
import MenuTipoPoi from "./MenuTipoPoi";
import ListaPoi from "./ListaPoi";
import Regiones from "./Regiones";
import {getJSON} from "../constants/network";
import routes from "../constants/routes";

const defaultPage = 1;
const defaultItems = 10;
const defaultTipo = "";

export default class Buscar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            region: "",
            siguiente: false,
            anterior: false,
            tipos: [],
            pois: false,
            publicidad: []
        };
    }

    loadFromServer(props) {
        let query = queryString.parse(props.location.search);
        let q = query.q;
        let page = query.page || defaultPage;
        let items = query.items || defaultItems;
        let tipo = query.tipo || defaultTipo;

        let urlBuscar = `${routes.buscar}?q=${q}&page=${page}&items=${items}&tipo=${tipo}`;
        let urlPaginacion = `${routes.buscar}?q=${q}&page=${page + 1}&items=${items}&tipo=${tipo}`;

        let poisResult = [];
        let pubResult = [];

        getJSON(urlBuscar).then(result => {
            poisResult = result.data.pois;
            pubResult = result.data.publicidad;

            return getJSON(urlPaginacion);
        }).then(result2 => {
            this.setState({
                pois: poisResult,
                publicidad: pubResult,
                anterior: parseInt(page, 10) > 1,
                siguiente: result2.data.pois.length > 0
            });
        });

        getJSON(routes.tipoPoiAll)
            .then(results => {
                let tipos = [];
                results.data.forEach(tipo => {
                    tipos.push({tipo});
                });
                this.setState({tipos})
            })
    }

    componentDidMount() {
        this.loadFromServer(this.props);
    }
    componentDidUpdate() {
        hideHeader();
    }

    componentWillReceiveProps(nextProps) {
        let nextQuery = queryString.parse(nextProps.location.search);
        let query = queryString.parse(this.props.location.search);
        let newQ = nextQuery.q;
        let oldQ = query.q;

        let newPage = parseInt(nextQuery.page, 10) || defaultPage;
        let oldPage = parseInt(query.page, 10);

        let newItems = nextQuery.items || defaultItems;
        let oldItems = query.items;

        let newTipo = nextQuery.tipo || defaultTipo;
        let oldTipo = query.tipo;

        if (newQ !== oldQ || oldPage !== newPage || oldItems !== newItems || newTipo !== oldTipo) {
            this.setState({
                pois: false
            }, () => this.loadFromServer(nextProps));
        }
    }

    render() {
        let qs = queryString.parse(this.props.location.search);
        let query = qs.q;
        let page = qs.page || defaultPage;
        let item = qs.items || defaultItems;
        let tipo = qs.tipo || defaultTipo;
        let nextPage = parseInt(page, 10) + 1;
        let prevPage = parseInt(page, 10) - 1;
        let hayAnterior = this.state.anterior;
        let haySiguiente = this.state.siguiente;

        let nextPageLink = <li/>;
        if (haySiguiente) {
            nextPageLink = (
                <li className="next">
                    <Link to={`/buscar?q=${query}&page=${nextPage}&items=${item}&tipo=${tipo}`}>Siguiente</Link>
                </li>
            );
        }
        let prevPageLink = <li/>;
        if (hayAnterior) {
            prevPageLink = (
                <li className="previous">
                    <Link to={`/buscar?q=${query}&page=${prevPage}&items=${item}&tipo=${tipo}`}>Anterior</Link>
                </li>
            );
        }

        return (
            <div>
                <div id="cambio-sector" className="region-todas">
                    <div className="contenedor-sector">
                        <Breadcrumb links={[{url: null, text: "Buscar: " + query}]}/>
                    </div>
                </div>
                <div className="contenedor-menu-tipo-poi">
                    <div className="contenedor-sector" id="container_menu_tipo_poi">
                        <MenuTipoPoi tipos={this.state.tipos}
                                     baseUrl={`/buscar?q=${query}&page=${page}&item=${item}`}
                                     elegido={qs.tipo}
                                     inSearch={true}
                        />
                    </div>
                </div>

                <div className="contenedor-sector">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3>Resultados de la Búsqueda: {query}</h3>
                            {
                                (() => {
                                    if (this.state.pois === false) {
                                        return <Vacio/>
                                    }
                                    return <ListaPoi
                                        showSector={true}
                                        showRuta={true}
                                        showEstado={true}
                                        pois={this.state.pois}
                                        publicidad={this.state.publicidad}/>
                                })()
                            }
                            {
                                (() => {
                                    if (this.state.pois !== false) {
                                        return <div className="col-sm-9 col-sm-offset-3">
                                            <nav>
                                                <ul className="pager">
                                                    {prevPageLink}
                                                    {nextPageLink}
                                                </ul>
                                            </nav>
                                        </div>
                                    }
                                })()
                            }
                        </div>
                    </div>
                </div>
                <div className="include-region">
                    <Regiones completo={false}/>
                </div>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Buscar.js